import React from 'react'
import "./select.scss";
import { Link } from "react-router-dom";

import smartgenz_group from "./img/select/smartgenz_group.png";
import smartgenz_webservices from "./img/select/smartgenz_webservices.png";
import smartgenz_support from "./img/select/smartgenz_support.png";
import { Helmet, HelmetProvider } from 'react-helmet-async'

export default function Select() {
  return (
    <>
      <HelmetProvider>
          <Helmet prioritizeSeoTags>
              <meta charset="utf-8" />
              <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1"
              />
              <meta name="theme-color" content="#005bac" />
              <meta
                  name="keywords"
                  content="千葉県千葉市web制作,千葉市格安ホームページ制作,千葉市web集客,smartgenz,パドリナアレン"
              />
              <meta
                  name="description"
                  content="千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。ブランディングとリードジェネレーションを融合させたWebサイトを構築し、集客やターゲット顧客への商品・サービスの価値を伝えます。"
              />
              <meta
                  property="og:title"
                  content="千葉県千葉市でのホームページ制作ならSmartGenz | トップページ"
              />
              <meta
                  property="og:description"
                  content="千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。ブランディングとリードジェネレーションを融合させたWebサイトを構築し、集客やターゲット顧客への商品・サービスの価値を伝えます。"
              />
              <meta property="og:type" content="article" />
              <meta property="og:url" content="https://smartgenz.com/" />
              <meta
                  property="og:image"
                  content="%PUBLIC_URL%/smartgenz.jpg"
              />
              <meta
                  property="og:site_name"
                  content="千葉県千葉市でのホームページ制作ならSmartGenz"
              />
              <meta property="og:locale" content="ja_JP" />
              <link
                  rel="apple-touch-icon"
                  href="%PUBLIC_URL%/smartgenz.jpg"
              />
              <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
              <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
              <link rel="canonical" href="https://smartgenz.com/" />
              <title>
                  千葉県千葉市でのホームページ制作ならSmartGenz |
                  トップページ
              </title>
          </Helmet>
      </HelmetProvider>
      <div className='sle_area'>
        <div className='sle_title'>
          <div className='smartgenz_group_img'>
          <img src={smartgenz_group} alt="smartgenz_group" />
          </div>

        </div>
        <div className='select_block'>
          <div className='it_block'>
            <Link to="/it" className='smartgenz_it'>
              <img src={smartgenz_webservices} alt="smartgenz_it" />
            </Link>
            <div className='text_int'>※ウェブ制作コンテンツについてはこちら</div>
          </div>
          <div  className='support_block'>
            <Link to="/support" className='smartgenz_support'>
            <img src={smartgenz_support} alt="smartgenz_support" />
            </Link>
            <div className='text_int'>※仮設事業及びメインテナンスについてはこちら</div>
          </div>
        </div>
        <div className='sle_select'>
          ご覧いただきたいウェブサイトをお選びいただけますでしょうか。
        </div>
      </div>
    </>
  )
}
